module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAALCAYAAABGbhwYAAAA00lEQVQoU4XQsUpCcRTH8e/v3ovQKwRCOBr0DEFjBFGP0KTgAwii6W1ojNpyc+gBgiBXB8HJyQdwF3cp/7+4Xa5F1O1Mh9/5HA4cUVT/7QSpgXSEEXiBGdJLXjKiT9fftoho75a+N+KeTnwrUh9DePoVFWHwlbjZDjGnpRBPRBpm4Go5ZJ3BKfigFJqVGLw/IF3+c/pVDHyIwhiI/sSKzvP3pL6AcAckP7Cx23STUQ6zut7UieJHpFoeeIlDk25l/vXwAve8TxyekSpoc0Znb1mMPgCe+j50oWPzxQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map/route/endPoint.png
// module id = 447s
// module chunks = 2